// src/components/layout/PageHeader/DashboardHeader.jsx
import React, { useState } from "react";
import { Button } from "antd";
import { PrintIcon, ExportIcon } from "../../../assets/svgs/icons";
import ExportModalOrganization from "../../Modals/Organizations/ExportModalOrganization";
import { useSelector } from "react-redux";
import { selectCurrentRole } from "../../../store/auth/authSlice";

const DashboardHeader = ({
  selectedPeriod,
  onPeriodChange,
  collapsed,
  handleToggle,
  showToggle = true,
  onExport,
  onPrint,
  disabled = false,
}) => {
  const userRole = useSelector(selectCurrentRole);

  const [exportOrganizationModalVisible, setExportModalOrganizationVisible] =
    useState(false);

  const getActions = () => {
    const actions = [
      {
        key: "print",
        label: "Print Analytics",
        icon: <PrintIcon />,
        type: "secondary",
        className: "no-print",
      },
    ];

    if (userRole === "admin") {
      actions.push({
        key: "export",
        label: "Export Report",
        icon: <ExportIcon />,
        type: "primary",
        className: "no-print",
      });
    }

    return actions;
  };

  return (
    <div className="bg-white relative mb-4 pb-2 border-b border-gray-200">
      <div className="transition-all duration-300 w-full  py-0">
        <div className="flex flex-wrap md:flex-nowrap items-center md:items-end justify-start">
          <div className="flex-grow">
            <h1 className="text-xl md:text-2xl font-bold text-gray-900 mb-1 mt-0">
              Dashboard Analytics
            </h1>
            <p className="text-gray-500 text-sm mb-0 mr-1">
              Gain insights into the performance and responses of your forms.
              Track interpreter activities, form statuses, and completion
              metrics.
            </p>
          </div>
          <div className="flex items-center gap-2 md:gap-3 mt-4 md:mt-0 md:ml-auto no-print">
            {getActions().map((action) => (
              <Button
                key={action.key}
                type={action.type}
                icon={action.icon}
                className={`${
                  action.type === "primary" ? "btnPrimary" : "btnSecondary"
                }  ${action.className || ""}`}
                onClick={() => {
                  if (action.key === "export") {
                    onExport?.();
                    setExportModalOrganizationVisible(true);
                  } else if (action.key === "print") {
                    onPrint?.();
                  }
                }}
                disabled={disabled}
              >
                {action.label}
              </Button>
            ))}
          </div>
        </div>
      </div>
      <ExportModalOrganization
        visible={exportOrganizationModalVisible}
        onClose={() => setExportModalOrganizationVisible(false)}
        className="no-print"
      />
    </div>
  );
};

export default DashboardHeader;
